// src/utils/lucideToSvg.js

import { renderToStaticMarkup } from 'react-dom/server';
import React from 'react';

/**
 * Convert Lucide React icon to colored SVG data URL for Google Maps
 * @param {React.Component} IconComponent - Lucide icon component
 * @param {string} color - Hex color (e.g., '#FF6347')
 * @param {number} size - Icon size in pixels
 * @returns {string} Data URL for the colored SVG
 */
export const lucideIconToDataUrl = (IconComponent, color, size = 32) => {
  // Render the icon to static SVG markup
  const svgString = renderToStaticMarkup(
    <IconComponent
      color={color}
      size={size}
      strokeWidth={2}
    />
  );

  // Convert to data URL
  const encodedSVG = encodeURIComponent(svgString);
  return `data:image/svg+xml,${encodedSVG}`;
};

/**
 * Get Google Maps marker icon config from Lucide icon
 * @param {React.Component} IconComponent - Lucide icon component
 * @param {string} color - Hex color
 * @param {number} size - Icon size in pixels
 * @returns {object} Google Maps icon configuration
 */
export const getLucideMarkerIcon = (IconComponent, color, size = 24) => {
  return {
    url: lucideIconToDataUrl(IconComponent, color, size),
    scaledSize: new window.google.maps.Size(size, size),
    anchor: new window.google.maps.Point(size / 2, size),
    origin: new window.google.maps.Point(0, 0)
  };
};

/**
 * Render Lucide icon as inline element (for UI components)
 * @param {React.Component} IconComponent - Lucide icon component
 * @param {string} color - Hex color
 * @param {number} size - Icon size in pixels
 * @returns {React.Element} Rendered icon
 */
export const renderLucideIcon = (IconComponent, color, size = 24) => {
  return <IconComponent color={color} size={size} strokeWidth={2} />;
};